import allCandidates from './data/candidates'
const districts = Object.keys(allCandidates)

module.exports = search => {
    let answers = []
    let weightedOpinion
    let district

    if (search) {
        const params = search.replace('?', '').split('&')
        params.forEach(param => {
            let [ key, value ] = param.split('=')
            if (key && value) {
                if (key === 'd') {
                    if (districts.includes(value)) {
                        district = value
                    }
                } else if (district) { // district has to be first value to search params to be valid
                    if (value === '2' || value === '-2') {
                        weightedOpinion = key
                        value = value / 2
                    }
                    answers.push({
                        question: key,
                        opinion: value * .75,
                    })
                }
            }
        })
    }

    window.history.replaceState({ district, answers, weightedOpinion }, false)

    return {
        filters: {
            party: [],
            ageGroup: [],
            gender: [],
        },
        weightedOpinion,
        answers,
        district,
    }
}